module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Gc-Ha-Id-Ja.13324bde.png";